import React from "react";
import { PostData } from "../../api/service";
import {
  Button,
  Card,
  Empty,
  Input,
  InputNumber,
  Popover,
  Spin,
  message,
  Tag,
} from "antd";
import { Grid, Avatar } from "@material-ui/core";
import CardTravel from "@material-ui/icons/CardTravel";
import Group from "@material-ui/icons/Group";
import LocalActivity from "@material-ui/icons/LocalActivity";
import Whatshot from "@material-ui/icons/Whatshot";
import TrendingUp from "@material-ui/icons/TrendingUp";
import FilterList from "@material-ui/icons/FilterList";
import DateRange from "@material-ui/icons/DateRange";
import Star from "@material-ui/icons/Star";
import Search from "@material-ui/icons/Search";
import Person from "@material-ui/icons/Person";
import ReactHTMLTableToExcel from "react-html-table-to-excel";

const COLORS = {
  primary: "#5B21B6",
  primaryLight: "#EDE9FE",
  card1: "#5B21B6",
  card2: "#0EA5E9",
  card3: "#F59E0B",
  card4: "#10B981",
  text: "#1F2937",
  muted: "#6B7280",
  border: "#E5E7EB",
  rowAlt: "#F9FAFB",
  headerRow: "#F3F4F6",
  rank1: "#F59E0B",
  rank2: "#94A3B8",
  rank3: "#B45309",
};

function StatCard({ icon, label, value, background }) {
  return (
    <div
      style={{
        background,
        color: "white",
        borderRadius: 12,
        padding: "20px 22px",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        boxShadow: "0 4px 14px rgba(0,0,0,0.08)",
        minHeight: 110,
      }}
    >
      <div>
        <div style={{ fontSize: 13, opacity: 0.85, fontWeight: 500, letterSpacing: 0.3 }}>
          {label}
        </div>
        <div style={{ fontSize: 32, fontWeight: 700, marginTop: 6, lineHeight: 1 }}>
          {value}
        </div>
      </div>
      <div
        style={{
          background: "rgba(255,255,255,0.18)",
          borderRadius: "50%",
          width: 52,
          height: 52,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        {icon}
      </div>
    </div>
  );
}

function RankBadge({ rank }) {
  if (rank === 1) {
    return (
      <div
        style={{
          background: COLORS.rank1,
          color: "white",
          width: 30,
          height: 30,
          borderRadius: "50%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          fontWeight: 700,
          fontSize: 13,
        }}
      >
        <Star style={{ fontSize: 18 }} />
      </div>
    );
  }
  if (rank === 2 || rank === 3) {
    const bg = rank === 2 ? COLORS.rank2 : COLORS.rank3;
    return (
      <div
        style={{
          background: bg,
          color: "white",
          width: 30,
          height: 30,
          borderRadius: "50%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          fontWeight: 700,
          fontSize: 13,
        }}
      >
        {rank}
      </div>
    );
  }
  return (
    <div
      style={{
        background: "#F3F4F6",
        color: COLORS.text,
        width: 30,
        height: 30,
        borderRadius: "50%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontWeight: 600,
        fontSize: 13,
      }}
    >
      {rank}
    </div>
  );
}

function MembersList({ members, side }) {
  if (!Array.isArray(members) || members.length === 0) {
    return (
      <div style={{ padding: 8, color: COLORS.muted, fontSize: 12 }}>
        No members activated in this window.
      </div>
    );
  }
  const accent = side === "LEFT" ? "#3730A3" : "#92400E";
  const accentBg = side === "LEFT" ? "#EEF2FF" : "#FEF3C7";
  return (
    <div style={{ width: 280 }}>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          padding: "6px 4px 10px 4px",
          borderBottom: `1px solid ${COLORS.border}`,
          marginBottom: 8,
        }}
      >
        <span style={{ fontWeight: 600, color: COLORS.text, fontSize: 13 }}>
          {side} leg members
        </span>
        <span
          style={{
            background: accentBg,
            color: accent,
            fontWeight: 700,
            fontSize: 11,
            padding: "2px 8px",
            borderRadius: 6,
          }}
        >
          {members.length}
        </span>
      </div>
      <div style={{ maxHeight: 260, overflowY: "auto" }}>
        <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 12 }}>
          <thead>
            <tr>
              <th
                style={{
                  textAlign: "left",
                  padding: "4px 6px",
                  fontWeight: 600,
                  color: COLORS.muted,
                  fontSize: 11,
                  textTransform: "uppercase",
                  letterSpacing: 0.3,
                }}
              >
                #
              </th>
              <th
                style={{
                  textAlign: "left",
                  padding: "4px 6px",
                  fontWeight: 600,
                  color: COLORS.muted,
                  fontSize: 11,
                  textTransform: "uppercase",
                  letterSpacing: 0.3,
                }}
              >
                User ID
              </th>
              <th
                style={{
                  textAlign: "right",
                  padding: "4px 6px",
                  fontWeight: 600,
                  color: COLORS.muted,
                  fontSize: 11,
                  textTransform: "uppercase",
                  letterSpacing: 0.3,
                }}
              >
                Activated
              </th>
            </tr>
          </thead>
          <tbody>
            {members.map((m, i) => (
              <tr
                key={m.user_id + i}
                style={{
                  background: i % 2 === 0 ? "white" : "#FAFAFA",
                }}
              >
                <td
                  style={{
                    padding: "5px 6px",
                    color: COLORS.muted,
                    fontFamily: "monospace",
                  }}
                >
                  {i + 1}
                </td>
                <td
                  style={{
                    padding: "5px 6px",
                    fontFamily: "monospace",
                    color: COLORS.text,
                  }}
                >
                  {m.user_id}
                </td>
                <td
                  style={{
                    padding: "5px 6px",
                    textAlign: "right",
                    color: COLORS.muted,
                    fontFamily: "monospace",
                  }}
                >
                  {m.activation_date}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

function initials(name) {
  if (!name) return "?";
  const parts = String(name).trim().split(/\s+/).slice(0, 2);
  return parts.map((p) => p[0]).join("").toUpperCase();
}

export default function TravelSchemeReport() {
  const [state, setState] = React.useState({
    start_date: "",
    end_date: "",
    min_pair_count: 30,
  });

  const [data, setData] = React.useState([]);
  const [isLoaded, setIsLoaded] = React.useState(false);
  const [isSubmitting, setIsSubmitting] = React.useState(false);
  const [lastQuery, setLastQuery] = React.useState(null);

  function onChange(name, value) {
    setState({ ...state, [name]: value });
  }

  function onSubmit() {
    if (
      state.start_date === "" ||
      state.end_date === "" ||
      state.min_pair_count === "" ||
      state.min_pair_count === null
    ) {
      message.error("Please fill in start date, end date and minimum pair count");
      return;
    }
    if (state.start_date > state.end_date) {
      message.error("Start date must be on or before end date");
      return;
    }

    setIsSubmitting(true);
    PostData(`/travel-scheme-report`, state)
      .then((resp) => {
        setData(Array.isArray(resp) ? resp : []);
        setLastQuery({ ...state });
        setIsLoaded(true);
        setIsSubmitting(false);
      })
      .catch(() => {
        message.error(`Error in server`);
        setIsSubmitting(false);
      });
  }

  const stats = React.useMemo(() => {
    if (!Array.isArray(data) || data.length === 0) {
      return { qualified: 0, totalPairs: 0, highest: 0, avg: 0 };
    }
    const totalPairs = data.reduce((s, r) => s + (r.pair_count || 0), 0);
    const highest = data.reduce((m, r) => Math.max(m, r.pair_count || 0), 0);
    return {
      qualified: data.length,
      totalPairs,
      highest,
      avg: (totalPairs / data.length).toFixed(1),
    };
  }, [data]);

  return (
    <div style={{ background: "#F9FAFB", minHeight: "100vh", paddingBottom: 40 }}>
      {/* Header banner */}
      <div
        style={{
          background: `linear-gradient(135deg, ${COLORS.primary} 0%, #7C3AED 100%)`,
          color: "white",
          padding: "28px 32px",
          borderBottomLeftRadius: 20,
          borderBottomRightRadius: 20,
        }}
      >
        <div style={{ display: "flex", alignItems: "center", gap: 16 }}>
          <div
            style={{
              background: "rgba(255,255,255,0.18)",
              borderRadius: 14,
              width: 56,
              height: 56,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <CardTravel style={{ fontSize: 28 }} />
          </div>
          <div>
            <div style={{ fontSize: 22, fontWeight: 700, letterSpacing: 0.2 }}>
              Travel Scheme Report
            </div>
            <div style={{ fontSize: 13, opacity: 0.9, marginTop: 4 }}>
              Users whose paired downline, activated within the selected window,
              meets the minimum pair count and qualifies for the travel award.
            </div>
          </div>
        </div>
      </div>

      <div style={{ padding: "20px 24px" }}>
        {/* Filter card */}
        <Card
          bordered={false}
          style={{
            borderRadius: 12,
            boxShadow: "0 2px 8px rgba(0,0,0,0.04)",
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: 8,
              marginBottom: 14,
              color: COLORS.text,
              fontWeight: 600,
              fontSize: 15,
            }}
          >
            <FilterList style={{ fontSize: 20, color: COLORS.primary }} />
            Filters
          </div>
          <Grid container spacing={16}>
            <Grid item xs={12} sm={6} md={3}>
              <div
                style={{
                  fontWeight: 600,
                  fontSize: 12,
                  color: COLORS.muted,
                  marginBottom: 6,
                  display: "flex",
                  alignItems: "center",
                  gap: 4,
                }}
              >
                <DateRange style={{ fontSize: 14 }} />
                START DATE
              </div>
              <Input
                type="date"
                value={state.start_date}
                onChange={(e) => onChange("start_date", e.target.value)}
                style={{ borderRadius: 8, height: 40 }}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <div
                style={{
                  fontWeight: 600,
                  fontSize: 12,
                  color: COLORS.muted,
                  marginBottom: 6,
                  display: "flex",
                  alignItems: "center",
                  gap: 4,
                }}
              >
                <DateRange style={{ fontSize: 14 }} />
                END DATE
              </div>
              <Input
                type="date"
                value={state.end_date}
                onChange={(e) => onChange("end_date", e.target.value)}
                style={{ borderRadius: 8, height: 40 }}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <div
                style={{
                  fontWeight: 600,
                  fontSize: 12,
                  color: COLORS.muted,
                  marginBottom: 6,
                  display: "flex",
                  alignItems: "center",
                  gap: 4,
                }}
              >
                <LocalActivity style={{ fontSize: 14 }} />
                MINIMUM PAIR COUNT
              </div>
              <InputNumber
                min={0}
                style={{ width: "100%", borderRadius: 8, height: 40 }}
                value={state.min_pair_count}
                onChange={(v) => onChange("min_pair_count", v)}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <div style={{ height: 24 }} />
              <Button
                type="primary"
                icon={<Search style={{ fontSize: 16, marginRight: 6, verticalAlign: -3 }} />}
                loading={isSubmitting}
                onClick={onSubmit}
                style={{
                  height: 40,
                  width: "100%",
                  borderRadius: 8,
                  background: COLORS.primary,
                  borderColor: COLORS.primary,
                  fontWeight: 600,
                }}
              >
                Search
              </Button>
            </Grid>
          </Grid>
          {lastQuery && (
            <div
              style={{
                marginTop: 14,
                paddingTop: 12,
                borderTop: `1px dashed ${COLORS.border}`,
                display: "flex",
                gap: 8,
                flexWrap: "wrap",
                alignItems: "center",
                fontSize: 12,
                color: COLORS.muted,
              }}
            >
              <span>Showing results for:</span>
              <Tag color="purple" style={{ borderRadius: 6 }}>
                {lastQuery.start_date} → {lastQuery.end_date}
              </Tag>
              <Tag color="geekblue" style={{ borderRadius: 6 }}>
                min pair count ≥ {lastQuery.min_pair_count}
              </Tag>
            </div>
          )}
        </Card>

        {/* Loading state */}
        {isSubmitting && (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              minHeight: 200,
            }}
          >
            <Spin size="large" />
          </div>
        )}

        {/* Stats cards */}
        {isLoaded && !isSubmitting && data.length > 0 && (
          <div style={{ marginTop: 20 }}>
            <Grid container spacing={16}>
              <Grid item xs={12} sm={6} md={3}>
                <StatCard
                  background={`linear-gradient(135deg, ${COLORS.card1} 0%, #7C3AED 100%)`}
                  label="QUALIFIED USERS"
                  value={stats.qualified}
                  icon={<Group style={{ fontSize: 26, color: "white" }} />}
                />
              </Grid>
              <Grid item xs={12} sm={6} md={3}>
                <StatCard
                  background={`linear-gradient(135deg, ${COLORS.card2} 0%, #0284C7 100%)`}
                  label="TOTAL PAIRS"
                  value={stats.totalPairs}
                  icon={<LocalActivity style={{ fontSize: 26, color: "white" }} />}
                />
              </Grid>
              <Grid item xs={12} sm={6} md={3}>
                <StatCard
                  background={`linear-gradient(135deg, ${COLORS.card3} 0%, #D97706 100%)`}
                  label="HIGHEST PAIR COUNT"
                  value={stats.highest}
                  icon={<Whatshot style={{ fontSize: 26, color: "white" }} />}
                />
              </Grid>
              <Grid item xs={12} sm={6} md={3}>
                <StatCard
                  background={`linear-gradient(135deg, ${COLORS.card4} 0%, #059669 100%)`}
                  label="AVERAGE PAIR COUNT"
                  value={stats.avg}
                  icon={<TrendingUp style={{ fontSize: 26, color: "white" }} />}
                />
              </Grid>
            </Grid>
          </div>
        )}

        {/* Empty state */}
        {isLoaded && !isSubmitting && data.length === 0 && (
          <Card
            bordered={false}
            style={{
              marginTop: 20,
              borderRadius: 12,
              boxShadow: "0 2px 8px rgba(0,0,0,0.04)",
              padding: 40,
            }}
          >
            <Empty description="No users met the minimum pair count in the selected date range" />
          </Card>
        )}

        {/* Results table */}
        {isLoaded && !isSubmitting && data.length > 0 && (
          <Card
            bordered={false}
            style={{
              marginTop: 20,
              borderRadius: 12,
              boxShadow: "0 2px 8px rgba(0,0,0,0.04)",
              overflow: "hidden",
            }}
            bodyStyle={{ padding: 0 }}
          >
            <div
              style={{
                padding: "16px 20px",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                borderBottom: `1px solid ${COLORS.border}`,
              }}
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: 10,
                  color: COLORS.text,
                  fontWeight: 600,
                  fontSize: 15,
                }}
              >
                <CardTravel style={{ fontSize: 20, color: COLORS.primary }} />
                Qualified Users
                <Tag color="purple" style={{ borderRadius: 6, marginLeft: 4 }}>
                  {data.length}
                </Tag>
              </div>
              <ReactHTMLTableToExcel
                id="travel-scheme-xls-button"
                className="download-table-xls-button"
                table="table-to-xls"
                filename={`Travel Scheme Report`}
                sheet="tablexls"
                buttonText="Download XLS"
              />
            </div>

            <div style={{ overflowX: "auto" }}>
              <table
                id="table-to-xls"
                style={{
                  width: "100%",
                  borderCollapse: "collapse",
                  fontSize: 13,
                }}
              >
                <thead>
                  <tr style={{ background: COLORS.headerRow }}>
                    <th style={thStyle}>#</th>
                    <th style={thStyle}>User</th>
                    <th style={thStyle}>Phone</th>
                    <th style={thStyle}>Sponsor</th>
                    <th style={thStyle}>Activation Date</th>
                    <th style={{ ...thStyle, textAlign: "center" }}>
                      Left <span style={{ color: COLORS.muted, fontWeight: 400 }}>(in range)</span>
                    </th>
                    <th style={{ ...thStyle, textAlign: "center" }}>
                      Right <span style={{ color: COLORS.muted, fontWeight: 400 }}>(in range)</span>
                    </th>
                    <th style={{ ...thStyle, textAlign: "center" }}>Pair Count</th>
                  </tr>
                </thead>
                <tbody>
                  {data.map((el, index) => {
                    const rank = index + 1;
                    return (
                      <tr
                        key={el.user_id}
                        style={{
                          background: index % 2 === 0 ? "white" : COLORS.rowAlt,
                          borderBottom: `1px solid ${COLORS.border}`,
                        }}
                      >
                        <td style={tdStyle}>
                          <RankBadge rank={rank} />
                        </td>
                        <td style={tdStyle}>
                          <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                            <Avatar
                              style={{
                                background: COLORS.primaryLight,
                                color: COLORS.primary,
                                width: 36,
                                height: 36,
                                fontSize: 13,
                                fontWeight: 700,
                              }}
                            >
                              {initials(el.name) || <Person style={{ fontSize: 18 }} />}
                            </Avatar>
                            <div>
                              <div style={{ fontWeight: 600, color: COLORS.text }}>
                                {el.name || <span style={{ color: COLORS.muted }}>—</span>}
                              </div>
                              <div style={{ fontSize: 11, color: COLORS.muted, fontFamily: "monospace" }}>
                                {el.user_id}
                              </div>
                            </div>
                          </div>
                        </td>
                        <td style={{ ...tdStyle, fontFamily: "monospace", color: COLORS.text }}>
                          {el.mno || <span style={{ color: COLORS.muted }}>—</span>}
                        </td>
                        <td style={{ ...tdStyle, fontFamily: "monospace", color: COLORS.muted }}>
                          {el.sponsor_id || "—"}
                        </td>
                        <td style={tdStyle}>{el.activation_date || <span style={{ color: COLORS.muted }}>—</span>}</td>
                        <td style={{ ...tdStyle, textAlign: "center" }}>
                          <Popover
                            content={<MembersList members={el.left_members} side="LEFT" />}
                            trigger="hover"
                            placement="right"
                            mouseEnterDelay={0.15}
                          >
                            <span
                              style={{
                                display: "inline-block",
                                minWidth: 40,
                                padding: "4px 10px",
                                background: "#EEF2FF",
                                color: "#3730A3",
                                borderRadius: 6,
                                fontWeight: 600,
                                cursor: "pointer",
                                borderBottom: "1px dashed #C7D2FE",
                              }}
                            >
                              {el.left_count_in_range}
                            </span>
                          </Popover>
                        </td>
                        <td style={{ ...tdStyle, textAlign: "center" }}>
                          <Popover
                            content={<MembersList members={el.right_members} side="RIGHT" />}
                            trigger="hover"
                            placement="right"
                            mouseEnterDelay={0.15}
                          >
                            <span
                              style={{
                                display: "inline-block",
                                minWidth: 40,
                                padding: "4px 10px",
                                background: "#FEF3C7",
                                color: "#92400E",
                                borderRadius: 6,
                                fontWeight: 600,
                                cursor: "pointer",
                                borderBottom: "1px dashed #FDE68A",
                              }}
                            >
                              {el.right_count_in_range}
                            </span>
                          </Popover>
                        </td>
                        <td style={{ ...tdStyle, textAlign: "center" }}>
                          <span
                            style={{
                              display: "inline-block",
                              minWidth: 48,
                              padding: "6px 14px",
                              background: rank === 1
                                ? `linear-gradient(135deg, ${COLORS.rank1} 0%, #D97706 100%)`
                                : `linear-gradient(135deg, ${COLORS.primary} 0%, #7C3AED 100%)`,
                              color: "white",
                              borderRadius: 8,
                              fontWeight: 700,
                              fontSize: 14,
                              boxShadow: "0 2px 4px rgba(0,0,0,0.08)",
                            }}
                          >
                            {el.pair_count}
                          </span>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </Card>
        )}
      </div>
    </div>
  );
}

const thStyle = {
  textAlign: "left",
  padding: "14px 16px",
  fontWeight: 600,
  fontSize: 12,
  color: "#374151",
  letterSpacing: 0.3,
  textTransform: "uppercase",
  borderBottom: `1px solid ${COLORS.border}`,
};

const tdStyle = {
  padding: "14px 16px",
  color: COLORS.text,
  verticalAlign: "middle",
};
